import { useNavigate } from "@reach/router";

export function useNavigator(navigate?: any) {
    const hookNav = useNavigate();
    return navigate || hookNav;
}
